/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Checkbox,
  Dropdown,
} from "semantic-ui-react";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { MyInput, MyNormalInput, MyTextArea } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import { translate } from "react-i18next";
import UpdateAxios from '../axiosComponent/update';
import moment, { ISO_8601 } from "moment";
import { Form as Formiker, Field, withFormik, ErrorMessage } from "formik";
import CancelReason from "../dynamicComponent/cancelReason";

const ModalCancelShipment = ({ success, error, shipment, values, isSubmitting, handleSubmit, setFieldValue, t }) => {
  const [modalOpen, setmodalOpen] = useState(false);

  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  let handleSubmited = () => {
    handleSubmit();
    // UpdateAxios({
    //     patchURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${shipment}/cancel`,
    //   })
    //     .then((res) => {
    //       // this.props.create(temShipment);
    //       props.successAlertDispatcher({
    //         type: "success",
    //         messageHeader: "Success",
    //         messageBody: res.data.message,
    //       });
    //       window.location.reload();
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       props.successAlertDispatcher({
    //         type: "success",
    //         messageHeader: "Success",
    //         messageBody: err.response.data.message,
    //       });
    //     });
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        style={{ overflow: "inherit" }}
        size="tiny"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            basic color="primary"
            variant="outlined" 
          // className="w3-blue w3-round w3-hover-blue"
          >
            {t("title-btn-name") || "Cancel"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {t("title") || "Cancel Shipment"}
        </Modal.Header>
        <Modal.Content>
          <p>{t("message") || "Are you sure you want to undo broadcast"}</p>

          <Formiker>

            <Field component={CancelReason} name="cancellation_reason" />
            <br />
            {values.cancellation_reason == '6' ?
              <Field component={MyTextArea} style={{ width: '100%' }} name="reason_text" className="mt-3" />
              : ''}

          </Formiker>

        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          {/* <Button
            type="submit"
            onClick={handleClose}
            // disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime)  ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("cancel") || "Cancel"}
          </Button> */}
          <Button
            type="submit"
            onClick={handleSubmited}
            // disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime)  ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("save") || "OK"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};

const FormikCancelShipment = withFormik({
  mapPropsToValues({ message }) {
    return {
      cancellation_reason: "",
    };
  },
  // validationSchema: Yup.object().shape({
  //   message: Yup.string().required("message Required"),
  // }),
  handleSubmit(values, { setSubmitting, props }) {
    console.log(props);
    console.log(values);
    UpdateAxios({
      patchURL: `${process.env.REACT_APP_TA_API_URL}/shipments/${props.shipment}/cancel/${values.cancellation_reason}`,
      payload: { ...values }
    })
      .then((res) => {
        // this.props.create(temShipment);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: err.response.data.message,
        });
      });
    // getValue(values.message)
    // props.rebidonSubmit
    // props.textareaValue(values.message)
  },
})(ModalCancelShipment);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("cancelShipment")(FormikCancelShipment)
);
